import React from 'react'
import styled from 'styled-components'

interface CardTitleProps {
    text?: string
}

const CardTitle: React.FC<CardTitleProps> = ({text}) => (
    <StyledCardTitle>{text}</StyledCardTitle>
);
export const CardSubTitle: React.FC<CardTitleProps> = ({text}) => (
    <StyledCardSubTitle>{text}</StyledCardSubTitle>
);

const StyledCardTitle = styled.div`
  color: ${(props) => props.theme.color.whites[1001]};
  font-size: 28px;
  font-weight: 700;
  padding: 10px 0;
  text-align: center;
`;
const StyledCardSubTitle = styled.div`
  padding: 10px 0;
  text-align: center;
  
font-size: 16px;
line-height: 1.4;
font-weight: 400;
color: #4F6294;

`;

export default CardTitle
